// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"96c7643a","885":"36e3ac4a"}[chunkId] + ".chunk.js";
};